/** Parses a cortex-data block's source: `source:` and `key:` lines, then `---`, then fallback. */
export function parseDataBlock(raw: string): { source: string; key: string; fallback: string } {
  const lines = raw.split("\n");
  const sep = lines.indexOf("---");
  const head = sep >= 0 ? lines.slice(0, sep) : lines;
  const read = (name: string) => head.find((l) => l.startsWith(`${name}:`))?.slice(name.length + 1).trim() ?? "";
  return { source: read("source"), key: read("key"), fallback: sep >= 0 ? lines.slice(sep + 1).join("\n").trim() : "" };
}
